// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCirDollarCircleFilledSvg from "@fishx/icons-svg/es/asn/PtoCirDollarCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PtoCirDollarCircleFilled = function PtoCirDollarCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCirDollarCircleFilledSvg
  }));
};

PtoCirDollarCircleFilled.displayName = 'PtoCirDollarCircleFilled';
export default React.forwardRef(PtoCirDollarCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCirDollarCircleFilled.js
// module id = 3894
// module chunks = 0